var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconTools128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 64.5029V112.503H22.6667C20.8257 112.503 19.1591 111.757 17.9526 110.55C16.7462 109.344 16 107.677 16 105.836V64.5029H64Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 64.5029V105.836C112 107.677 111.254 109.344 110.047 110.55C108.841 111.757 107.174 112.503 105.333 112.503H64V64.5029H112Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16.5029V64.5029H16V23.1696C16 21.3286 16.7462 19.662 17.9526 18.4556C19.1591 17.2491 20.8257 16.5029 22.6667 16.5029H64Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.333 16.5029C107.174 16.5029 108.841 17.2491 110.047 18.4556C111.254 19.662 112 21.3286 112 23.1696V64.5029H64V16.5029H105.333Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40.5029H100",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84.5029H100",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92.5029H100",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.457 80.9614L47.542 96.0464",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.543 80.9614L32.458 96.0464",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 40.5029H52",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40 28.5029L40 52.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconTools128);
export default __webpack_public_path__ + "static/media/pictogramBeaconTools128.833d60b09234787b21dd09c54ac8c01b.svg";
export { ForwardRef as ReactComponent };